import React, { useMemo } from "react";
import {
  type Icon,
  PersonSimpleWalkIcon,
  SubwayIcon,
  BicycleIcon,
  CarIcon,
  BabyIcon,
  BackpackIcon,
  GraduationCapIcon,
  ToteIcon,
  StorefrontIcon,
  ForkKnifeIcon,
  CoffeeIcon,
  MartiniIcon,
  DiscoBallIcon,
  BankIcon,
  SpeakerSimpleSlashIcon,
  TreeIcon,
  PlantIcon,
  FlowerLotusIcon,
} from "@phosphor-icons/react";
import { type Scores } from "@local-logic/client";

export type Score = keyof Scores["location"];

const icons: {
  [key in Score]: Icon;
} = {
  pedestrian_friendly: PersonSimpleWalkIcon,
  transit_friendly: SubwayIcon,
  cycling_friendly: BicycleIcon,
  car_friendly: CarIcon,
  daycares: BabyIcon,
  primary_schools: BackpackIcon,
  high_schools: GraduationCapIcon,
  shopping: ToteIcon,
  groceries: StorefrontIcon,
  restaurants: ForkKnifeIcon,
  cafes: CoffeeIcon,
  nightlife: MartiniIcon,
  vibrant: DiscoBallIcon,
  historic: BankIcon,
  quiet: SpeakerSimpleSlashIcon,
  parks: TreeIcon,
  greenery: PlantIcon,
  wellness: FlowerLotusIcon,
};

export const ScoreIcon = ({
  score,
  className,
  ...rest
}: {
  score: Score;
  className?: string;
  style?: React.CSSProperties;
}) => {
  const Icon = useMemo(() => icons[score], [score]);

  return <Icon className={className} {...rest} />;
};
